import React from "react";
import styles from "../assets/personnaliser.module.css"; // 🟡 assure-toi que ce fichier existe

const BoutonOnglet = ({ actif, onClick, children }) => {
  return (
    <button
      onClick={onClick}
      className={actif ? styles.activeTab : styles.tab}
    >
      {children}
    </button>
  );
};

export default BoutonOnglet;